import { useEffect, useState } from 'react';
import * as api from '../../api';

export const useDocumentImage = (
  encounterId: string,
  type: api.PatientUpload.DocumentType.PhotoID,
) => {
  const [url, setUrl] = useState<string>();
  const [error, setError] = useState<string>();

  useEffect(() => {
    setError(undefined);
    const getImageUrl = async () => {
      try {
        const document = await api.client.PatientUpload.findOneByType(
          encounterId,
          type,
        );
        if (!document) throw new Error('Cannot find document for given type');
        const { dataURL } = await api.client.PatientUpload.downloadImageFile(
          document.id,
        );
        setUrl(dataURL);
      } catch (e) {
        setError(e.message);
      }
    };
    getImageUrl();
  }, [encounterId, type]);

  return { url, error };
};
